import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../store/actions/index';
import { useTranslation } from 'react-i18next';
import * as actions from '../../store/actions/index';
import Select from 'react-select'


const ProjectModal = (props) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [navigation, setNaviation] = useState('base');

  const { register, setError, errors, handleSubmit, control, getValues } = useForm();

  const intialValues = props.initialValues;

  const onSubmit = data => {
    data = {...data,
      id: props.initialValues['id'],
      countrycode: Object(data.countrycode).code,
      customer_countrycode: Object(data.customer_countrycode).code }
    dispatch( props.onSubmitAction(data) ).then( (res) => {
      (res && res.errors)? errorHandling(res.errors) : dispatch(hideModal())
    });
  } ;

  const countryOptions = () => actions.availableCountries.map( x => { return { code: x.toLowerCase(), label:  t('countryname_' + x) }} )

  const setNav = (val) => {
    setNaviation(val);
  }

  const getNavStatus = (val) => {
    return (val === navigation)? " active" : ""
  }

  const errorHandling = (e) => {
    if ( Array.isArray(e['title']) ) {
      setError("title", {
              type: "manual",
              message: t('form.project.errors.title.' + e['title'][0]['error'] )
            });
    }
  }

  const fieldClassName = (error) => {
    return (error)? "form-control is-invalid" : "form-control"
  }


  const errorMessage = (errors, fieldName) => {
    return (errors[fieldName])?
       <div className="invalid-feedback">
          {t('form.project.errors.' + fieldName + '.required')}
        </div> : null
  }

  return (


         	<Modal show={true} onHide={props.hideModal} animation={true}>
         		<div className="modal-header">
         			<h5 className="modal-title">{props.modalTitle}</h5>
         			<button type="button" onClick={props.hideModal} className="close btn btn-round" data-dismiss="modal" aria-label="Close"> <i className="material-icons">close</i>
         			</button>
         		</div>
         		<Modal.Body>
                <ul className="nav nav-tabs nav-fill" role="tablist">
                  <li className="nav-item">
                    <a className={"nav-link" + getNavStatus('base')} role="tab" onClick={() => setNav('base')}>{ t( 'modal.project.navi.base') }</a>
                  </li>
                  <li className="nav-item">
                    <a className={"nav-link" + getNavStatus('contact')} onClick={() => setNav('contact')}>{ t( 'modal.project.navi.contact') }</a>
                  </li>
                  <li className="nav-item">
                    <a className={"nav-link" + getNavStatus('customer')} onClick={() => setNav('customer')}>{ t( 'modal.project.navi.customer') }</a>
                  </li>
                </ul><br />
                <form id="modal-form" onSubmit={handleSubmit(onSubmit)}>

                  <div style={{display: (navigation === 'base')? 'block' : 'none' }}>

                      <div className="form-group row">
                        <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.title.label')}</label>
                        <div className="col-sm-9">
                          <input
                            className={fieldClassName(errors.title)}
                            name="title"
                            defaultValue={intialValues.title}
                            ref={register({ required: true})} />
                          { errors.title && errorMessage(errors, 'title')}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="building" className="col col-form-label col-form-label-sm">{t( 'form.project.building.label')}</label>
                        <div className="col-sm-9">
                          <input
                            className={fieldClassName(errors.building)}
                            name="building"
                            defaultValue={intialValues.building}
                            ref={register({ required: false})} />
                          { errors.title && errorMessage(errors, 'building')}
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="street" className="col-sm-12 col-form-label col-form-label-sm">{t( 'form.project.street.label')}</label>
                        <div className="col-9">
                          <input
                            className="form-control"
                            name="street"
                            defaultValue={intialValues.street}
                            ref={register()} />
                        </div>
                        <div className="col">
                          <input
                            className="form-control"
                            name="housenumber"
                            defaultValue={intialValues.housenumber}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="street" className="col-sm-12 col-form-label col-form-label-sm">{t( 'form.project.zipcode.label')}</label>
                        <div className="col">
                          <input
                            className="form-control"
                            style={{paddingLeft: "7px", paddingRight: "7px"}}
                            name="zipcode"
                            defaultValue={intialValues.zipcode}
                            ref={register()} />
                        </div>
                        <div className="col-9">
                          <input
                            className="form-control"
                            name="city"
                            defaultValue={intialValues.city}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="district" className="col-sm-3 col-form-label col-form-label-sm">{t( 'form.project.district.label')}</label>
                        <div className="col-sm-9">
                          <input
                            className="form-control"
                            name="district"
                            defaultValue={intialValues.district}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3">{t( 'form.project.country.label')}</label>
                        <div className="col-sm-9">
                          <Controller
                              as={Select}
                              maxMenuHeight={250}
                              menuPlacement="top"
                              placeholder="Bitte wählen Sie ein Land"
                              defaultValue={countryOptions().find(o => o.code === intialValues.countrycode)}
                              options={countryOptions()}
                              getOptionLabel={option => option.label}
                              getOptionValue={option => option.code}
                              value={countryOptions().find(o => o.code === getValues("country"))}
                              onChange={([option]) => option.code}
                              name="countrycode"
                              register={register}
                              rules={{ required: false }}
                              control={control}
                              styles={{
                                control: (provided, { isFocused }) => ({
                                    ...provided,
                                    boxShadow: "0",
                                    fontSize: ".875rem",
                                    border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                                    ':hover': { border: "1px solid #dee2e6" }})
                                }}
                            />
                        </div>
                      </div>
         						</div>


                    <div style={{display: (navigation === 'contact')? 'block' : 'none' }}>

                        <div className="form-group row">
                          <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.contact_name.label')}</label>
                          <div className="col-sm-10">
                            <input
                              className="form-control"
                              name="contact_name"
                              defaultValue={intialValues.contact_name}
                              ref={register()} />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.contact_company.label')}</label>
                          <div className="col-sm-10">
                            <input
                              className="form-control"
                              name="contact_company"
                              defaultValue={intialValues.contact_company}
                              ref={register()} />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.contact_phone.label')}</label>
                          <div className="col-sm-10">
                            <input
                              className="form-control"
                              name="contact_phone"
                              defaultValue={intialValues.contact_phone}
                              ref={register()} />
                          </div>
                        </div>

                        <div className="form-group row">
                          <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.contact_email.label')}</label>
                          <div className="col-sm-10">
                            <input
                              className="form-control"
                              name="contact_email"
                              defaultValue={intialValues.contact_email}
                              ref={register()} />
                          </div>
                        </div>

                      </div>


                  <div style={{display: (navigation === 'customer')? 'block' : 'none' }}>

                      <div className="form-group row">
                        <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.customer_name.label')}</label>
                        <div className="col-sm-10">
                          <input
                            className="form-control"
                            name="customer_name"
                            defaultValue={intialValues.customer_name}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.customer_company.label')}</label>
                        <div className="col-sm-10">
                          <input
                            className="form-control"
                            name="customer_company"
                            defaultValue={intialValues.customer_company}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.customer_phone.label')}</label>
                        <div className="col-sm-10">
                          <input
                            className="form-control"
                            name="customer_phone"
                            defaultValue={intialValues.customer_phone}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="title" className="col col-form-label col-form-label-sm">{t( 'form.project.customer_email.label')}</label>
                        <div className="col-sm-10">
                          <input
                            className="form-control"
                            name="customer_email"
                            defaultValue={intialValues.customer_email}
                            ref={register()} />
                        </div>
                      </div>


                      <div className="form-group row">
                        <label htmlFor="street" className="col-sm-12 col-form-label col-form-label-sm">{t( 'form.project.customer_street.label')}</label>
                        <div className="col-9">
                          <input
                            className="form-control"
                            name="customer_street"
                            defaultValue={intialValues.customer_street}
                            ref={register()} />
                        </div>
                        <div className="col">
                          <input
                            className="form-control"
                            name="customer_housenumber"
                            defaultValue={intialValues.customer_housenumber}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="street" className="col-sm-12 col-form-label col-form-label-sm">{t( 'form.project.customer_zipcode.label')}</label>
                        <div className="col">
                          <input
                            className="form-control"
                            style={{paddingLeft: "7px", paddingRight: "7px"}}
                            name="customer_zipcode"
                            defaultValue={intialValues.customer_zipcode}
                            ref={register()} />
                        </div>
                        <div className="col-9">
                          <input
                            className="form-control"
                            name="customer_city"
                            defaultValue={intialValues.customer_city}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label htmlFor="district" className="col-sm-3 col-form-label col-form-label-sm">{t( 'form.project.customer_district.label')}</label>
                        <div className="col-sm-9">
                          <input
                            className="form-control"
                            name="customer_district"
                            defaultValue={intialValues.customer_district}
                            ref={register()} />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-3">{t( 'form.project.country.label')}</label>
                        <div className="col-sm-9">
                          <Controller
                              as={Select}
                              menuPlacement="top"
                              placeholder={ t( 'form.project.country.placeholder') }
                              defaultValue={countryOptions().find(o => o.code === intialValues.customer_countrycode)}
                              options={countryOptions()}
                              getOptionLabel={option => option.label}
                              getOptionValue={option => option.code}
                              value={countryOptions().find(o => o.code === getValues("country"))}
                              onChange={([option]) => option.code}
                              name="customer_countrycode"
                              register={register}
                              rules={{ required: false }}
                              control={control}
                              styles={{
                                control: (provided, { isFocused }) => ({
                                    ...provided,
                                    boxShadow: "0",
                                    fontSize: ".875rem",
                                    border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                                    ':hover': { border: "1px solid #dee2e6" }})
                                }}
                            />
                        </div>
                      </div>

                    </div>

                </form>
         		</Modal.Body>
         		<Modal.Footer>
         			<Button variant="secondary" onClick={props.hideModal}>{t( 'modals.common.button.close' )}</Button>
         			<button form="modal-form" type="submit" className="btn btn-primary">{t( 'modals.common.button.save' )}</button>
         		</Modal.Footer>
         	</Modal>


  )
}


const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal())
})

export default connect(null, mapDispatchToProps)(ProjectModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ProjectModal.js